var React = require('react');

function SquareInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-6519.33 -10460.577)"},React.createElement("path",{"d":"M8335.54 10611.9c0-40.1-15.95-78.6-44.33-107-28.38-28.4-66.88-44.3-107.02-44.3H6670.68c-40.14 0-78.63 15.9-107.02 44.3-28.38 28.4-44.33 66.9-44.33 107v1513.5c0 40.2 15.95 78.7 44.33 107.1 28.39 28.3 66.88 44.3 107.02 44.3h1513.51c40.14 0 78.64-16 107.02-44.3 28.38-28.4 44.33-66.9 44.33-107.1v-1513.5Z","fill":"currentColor","transform":"matrix(.33036 0 0 .33036 4365.61 7004.83)"})));
}

SquareInline.defaultProps = {"width":"600","height":"600","viewBox":"0 0 600 600"};

module.exports = SquareInline;

SquareInline.default = SquareInline;
